import { RouteRecordRaw } from 'vue-router'
import MeasurePointsChildRoutes from '@/router/measure-points'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'edit',
    name: 'measure-location.edit',
    component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/Edit.vue'),
  },
  {
    path: 'measure-points',
    name: 'measure-points',
    component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/MeasurePoints.vue'),
    // redirect: (to: RouteLocation) => ({ name: 'measure-points.map', params: to.params }),
    children: MeasurePointsChildRoutes
  },
]

export default routes
